var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDhlLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 294.869,
    height: 41.737,
    viewBox: "0 0 294.869 41.737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20.09 -15.285)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.09 15.285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,71.141H39.777l-2.15,2.9H0Zm0-5.5H43.924l-2.15,2.9H0ZM0,76.645H35.784l-2.15,2.9H0Z",
    transform: "translate(0 -37.967)",
    fill: "#d40511"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(251.099 27.673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M639.4,74.046H599.622l2.15-2.9H639.4Zm0,5.5h-43.77l2.15-2.9H639.4Zm-33.48-13.912H639.4v2.9H603.614Z",
    transform: "translate(-595.628 -65.638)",
    fill: "#d40511"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.548 16.053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.439,63.608l18.89-25.531h23.5c2.611,0,2.611.917,1.228,2.752-1.228,1.681-3.532,4.739-4.761,6.421-.614.917-1.843,2.6,2.15,2.6h31.484c-2.611,3.516-11.058,13.912-26.416,13.912-12.286-.153-46.073-.153-46.073-.153ZM199.866,49.7l-10.29,13.912h-27.03L172.836,49.7Zm39.162,0L228.738,63.608h-27.03L212,49.7Zm8.754,0s-2,2.752-2.918,3.975c-3.378,4.586-.46,9.937,10.75,9.937h43.463L309.367,49.7Z",
    transform: "translate(-91.439 -38.077)",
    fill: "#d40511"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.914,0l-9.368,12.689h51.3c2.611,0,2.611.917,1.229,2.752-1.229,1.681-3.379,4.739-4.761,6.574-.614.917-1.843,2.6,2.15,2.6H171.5s3.379-4.586,6.143-8.408c3.839-5.2.307-16.052-13.515-16.052C152,0,109.914,0,109.914,0ZM246.6,24.461H180.407L198.529,0h27.03L215.116,14.065h12.133L237.692,0h27.029ZM302.195,0,284.073,24.461H255.353L273.475,0Z",
    transform: "translate(-100.546 0)",
    fill: "#d40511"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhlLogo);
export default __webpack_public_path__ + "static/media/dhl_logo.73d446865f2f67bcdda3badf9c711bc7.svg";
export { ForwardRef as ReactComponent };